import { render, staticRenderFns } from "./VgvDisplayContainer.vue?vue&type=template&id=880455ee&"
import script from "./VgvDisplayContainer.vue?vue&type=script&lang=js&"
export * from "./VgvDisplayContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('880455ee')) {
      api.createRecord('880455ee', component.options)
    } else {
      api.reload('880455ee', component.options)
    }
    module.hot.accept("./VgvDisplayContainer.vue?vue&type=template&id=880455ee&", function () {
      api.rerender('880455ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/vgv/VgvDisplayContainer.vue"
export default component.exports